import type { MouseEvent as ReactMouseEvent } from 'react'
import { forwardRef } from 'react'

import { Button } from '@adverity/ds-component/button'
import { IconInfo } from '@adverity/ds-icon'

import { buttonLabel } from './constants/button-label'
import { Box } from '../box/box'
import type { PopoverTriggerRenderProps } from '../popover/types'

export type Props = PopoverTriggerRenderProps & {
    ariaControls?: string
    ariaExpanded?: boolean
    label?: string
}

const stylesTriggerProxy = {
    width: 'fit-content',
    height: 'fit-content',
} as const

export const InfoTipTrigger = forwardRef<HTMLButtonElement, Props>(
    ({ ariaControls, ariaExpanded, disabled, onClick, label }, ref) => (
        <Box css={stylesTriggerProxy}>
            {label ? (
                <Button
                    variant="minimal"
                    color="neutral"
                    aria-controls={ariaControls}
                    aria-expanded={ariaExpanded}
                    ref={ref}
                    onClick={(event: ReactMouseEvent<HTMLButtonElement>) => {
                        event.stopPropagation()
                        onClick?.(event)
                    }}
                    prefix={<IconInfo />}
                >
                    {label}
                </Button>
            ) : (
                <Button
                    variant="minimal"
                    color="neutral"
                    ref={ref}
                    size="small"
                    aria-controls={ariaControls}
                    aria-expanded={ariaExpanded}
                    disabled={disabled}
                    icon={<IconInfo />}
                    onClick={(event: ReactMouseEvent<HTMLButtonElement>) => {
                        event.stopPropagation()
                        onClick?.(event)
                    }}
                    label={buttonLabel}
                />
            )}
        </Box>
    ),
)

InfoTipTrigger.displayName = 'InfoTipTrigger'
